import React from 'react';
import './App.scss';
import UIConnectorAPI from './components/UIConnector-api'


function App() {
  return (
    <div className="App">
      <UIConnectorAPI />
      
    </div>
  );
}

export default App;
